import FilterServiceBase from '@/services/FilterServiceBase';
import { IRootState, IFilter } from '@/store/types/IRootState';
import { FilterType } from './FilterMutations';

const itemTypeFilterMutations = {
    cleanItemTypeFilters(state: IRootState) {
        // FilterServiceBase.mutations.cleanFilters(state.itemTypeFilters.filters);
        state.itemTypeFilters.filters = [];
    },
    checkItemTypeFilter(state: IRootState, { id }: { id: string } ) {
        state.itemTypeFilters.filters.filter(f => f.value === id).forEach(f => f.checked = !f.checked);
        state.currentMaxItems = state.defaultMaxItems;
    },
    populateItemTypeFilters(state: IRootState, itemTypes: any) {
        state.itemTypeFilters.filters =
            Object.keys(itemTypes).map( Id => ({
                name: Id,
                checked: false,
                value: Id.toString(),
                count: itemTypes[Id],
                type: FilterType.Tipo,
            } as IFilter));
    },
    toggleShowAllItemTypeFilters(state: IRootState) {
        state.itemTypeFilters.showAllFilters = !state.itemTypeFilters.showAllFilters;
    },
    toggleShowFilterGroupItemTypeFlag(state: IRootState) {
        state.itemTypeFilters.showFilterGroup = !state.itemTypeFilters.showFilterGroup;
    },
};

export default itemTypeFilterMutations;

export interface IPopulateItemTypeFiltersPayload {
    itemTypes: ItemType[];
}
export interface ItemType {
    id: string;
    name: string;
    count: number;
}
